import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import BrandMark from './BrandMark';
import { neveroverpayApi, signOut } from './neveroverpayApi';

export default function NeverOverpayNav({ mark = 'Home' }) {
  const [admin, setAdmin] = useState(false);
  const [menu, setMenu] = useState(false);

  useEffect(() => {
    neveroverpayApi.adminAccess()
      .then((row) => setAdmin(Boolean(row.is_admin || row.can_bootstrap)))
      .catch(() => setAdmin(false));
  }, []);

  function closeMenu() {
    setMenu(false);
  }

  return (
    <div className="np-appbar">
      <BrandMark to="/" kicker={mark} onClick={closeMenu} />
      <button
        type="button"
        className="np-nav-toggle"
        aria-expanded={menu}
        aria-controls="np-app-nav"
        onClick={() => setMenu((on) => !on)}
      >
        {menu ? 'Close' : 'Menu'}
      </button>
      <nav className={`np-nav-links${menu ? ' open' : ''}`} id="np-app-nav" aria-label="BilledTwice">
        <Link to="/app" onClick={closeMenu}>Home</Link>
        <Link to="/ledger" onClick={closeMenu}>Money saved</Link>
        <Link to="/ops" onClick={closeMenu}>Activity</Link>
        <Link to="/settings" onClick={closeMenu}>Settings</Link>
        {admin ? <Link to="/admin" onClick={closeMenu}>Admin</Link> : null}
        <button
          type="button"
          className="np-nav-signout"
          onClick={() => {
            closeMenu();
            signOut();
          }}
        >
          Sign out
        </button>
      </nav>
    </div>
  );
}
